import { FieldOptionBase } from 'module/api/field/types';

type HasPosition = Pick<FieldOptionBase, 'position'>;

export const byPosition = (a?: HasPosition, b?: HasPosition): number => {
  const aPosition = a?.position ?? -2;
  const bPosition = b?.position ?? -2;

  if (aPosition === bPosition) {
    return 0;
  }

  return aPosition > bPosition ? 1 : -1;
};
